import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { NetworkBackground } from '@/components/NetworkBackground';

export function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="relative isolate min-h-screen">
      <NetworkBackground className="fixed inset-0 -z-10 h-full w-full opacity-60" />

      <header className="border-b border-primary/20 bg-background/60 backdrop-blur-sm sticky top-0 z-20">
        <div className="container flex h-14 items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2.5 group outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md"
          >
            <span className="flex size-8 items-center justify-center rounded-lg bg-primary/20 border border-primary/40 group-hover:bg-primary/35 transition-colors">
              <ShieldCheck className="size-4.5 text-glow" />
            </span>
            <span className="font-display text-lg font-bold tracking-tight">
              Trust<span className="text-glow">Web</span>
            </span>
          </Link>
          <span className="hidden sm:block text-xs text-muted-foreground font-mono">
            web-of-trust oracle for nostr
          </span>
        </div>
      </header>

      <main className="relative">{children}</main>

      <footer className="border-t border-primary/20 mt-20">
        <div className="container py-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p className="max-w-md text-center sm:text-left text-xs leading-relaxed">
            TrustWeb scores are experimental heuristics of social-graph
            connectedness — not a measure of character or a safety guarantee.
          </p>
          <a
            href="https://shakespeare.diy"
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 text-glow hover:text-white transition-colors"
          >
            Vibed with Shakespeare
          </a>
        </div>
      </footer>
    </div>
  );
}
